const ITEMS = ["Real-time plotting", "G-code export", "Windows exclusive", "Industrial grade", "Shape library", "Free for makers"];

export const Marquee = () => (
  <div className="border-y border-white/10 py-6 overflow-hidden select-none" data-testid="marquee" aria-hidden="true">
    <div className="flex whitespace-nowrap animate-marquee w-max">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center">
          {ITEMS.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="font-display font-bold uppercase text-6xl sm:text-8xl tracking-tight text-stroke px-6">
                {item}
              </span>
              <span className="text-[#FF3B00] text-3xl">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
